import DatePickerInput from "../controls/DatePickerInput";

export default function DateFilter(props) {
  const { onChange, resetFilter, date, maxDate, hideTitle } = props;

  return (
    <div className={hideTitle ? "" : "p-3"}>
      <div className={hideTitle ? "hidden" : "flex justify-between"}>
        <p className="text-sm text-gray-700 font-semibold">Date</p>
        <button
          onClick={() => resetFilter()}
          className="text-sm font-semibold text-accent"
        >
          Reset
        </button>
      </div>
      <div className="gap-3 mt-1">
        <DatePickerInput
          label="Date:"
          name="date"
          onChange={(e) => onChange("date", e.target.value)}
          value={date}
          labelOn={false}
          maxDate={maxDate}
          type="text"
          dateFormat={"LLL dd, YYY"}
          labelDivClass="mb-0"
          labelClass="text-xs text-gray-500"
          dateOnly={true}
        />
      </div>
    </div>
  );
}
